import { graphql, useStaticQuery } from 'gatsby';
import type { Marketo } from 'types/types';

const useAlternateMarketoForm = (): Marketo.Interface => {
  const { allMarketoForm } = useStaticQuery(graphql`
    {
      allMarketoForm(filter: { marketoId: { eq: "438" } }) {
        edges {
          node {
            name
            marketoId
            description
            workSpaceId
            childrenMarketoFormField {
              apiId
              autoFill {
                parameterName
                value
                valueFrom
              }
              columnNumber
              dataType
              defaultValue
              fieldMetaData {
                initiallyChecked
                labelToRight
                values {
                  label
                  value
                  selected
                  isDefault
                }
                visibleLines
              }
              fieldWidth
              formPrefill
              hintText
              label
              labelWidth
              marketoId
              required
              rowNumber
              validationMessage
              visibilityRules {
                ruleType
                rules {
                  subjectField
                  operator
                  values
                  altLabel
                  picklistFilterValues {
                    label
                    value
                    selected
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return allMarketoForm?.edges[0].node;
};

export default useAlternateMarketoForm;
